import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_URL}/schools`;


export interface SchoolData {
  id?: number;
  name?: string;
  code?: string;
  address?: string;
  city?: string;
  zipCode?: string;
  country?: string;
  phone?: string;
  email?: string;
  website?: string;
  description?: string;
  adminId?: number;
  active?: boolean;
  state?: string;
  // ...other fields as needed
    schoolName: string;
  schoolCode: string;
  diseCode: string;
  jskAeo: string;
  block: string;
  district: string;
  pin: string;
  principalName: string;
  principalDesignation: string;
  principalMobile: string;
  principalEmail: string;
  classTeacherName: string;
  classTeacherDesignation: string;
  classTeacherMobile: string;
  classTeacherEmail: string;
  classState: string;
  className: string;
  year: string;
  medium: string[];
  basicMathsStudents: number;
  standardMathsStudents: number;
  totalStudents: number;
  academicYear: string;
}



// Fetch all schools
export const getAllSchools = async (): Promise<SchoolData[]> => {
  const response = await axios.get(API_URL);
  return response.data;
};

// Create a new school
export const createSchool = async (schoolData: SchoolData): Promise<SchoolData> => {
  const response = await axios.post(API_URL, schoolData);
  return response.data;
};

// Update an existing school
export const updateSchool = async (id: number, schoolData: SchoolData): Promise<SchoolData> => {
  const response = await axios.put(`${API_URL}/${id}`, schoolData);
  return response.data;
};

// Delete a school
export const deleteSchool = async (id: number): Promise<void> => {
  await axios.delete(`${API_URL}/${id}`);
};

export const getSchoolById = async (id: number): Promise<SchoolData> => {
  const response = await axios.get(`${API_URL}/${id}`);
  return response.data;
};
